import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import EfProductMultiSpec from '@elem/ui/ef-product-multi-spec';
import { formatMultiSpecData } from 'elem/utils/formatMultiSpecData';
import { getProductData } from '@elem/utils/getProductData';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ProductNav from '../../common/ProductNav';
import { generalKey, productPageTheme, generalKeys } from '../../config/pageConfig';
import { productDetailData, ResponseObj } from '@/service';
import styles from './index.module.scss';

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}
export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale } = useRouter();

    // const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    // const [productDataA, setProductDataA] = useState<any>({});
    const [productPageData, setProductPageData] = useState<any>({
        productCatagory: null,
        productSeries: [],
        supportDataArr: [],
    });

    useEffect(() => {
        const getProductSeriesData = async () => {
            const promiseAll = new Set();
            const proMsgAll: any[] = [];
            const productPageData = {
                productCatagory: null,
                productSeries: [] as any[],
                supportDataArr: [] as any[],
            };
            generalKeys?.map((item: GeneralKeyItemProps, _: number) => {
                const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
                if (Object.keys(productMsg)?.length > 0) {
                    proMsgAll.push(productMsg);
                    promiseAll.add(productDetailData({ handle: item.url }, locale || 'us'));
                }
            });

            Promise.all(promiseAll).then((resArr) => {
                resArr.map((resItem: any, resIndex) => {
                    if (resItem && resItem.code === '0') {
                        if (resIndex === 0) {
                            productPageData.productCatagory = resItem?.data?.productCatagoryResponseList;
                        }
                        productPageData.productSeries.push(resItem?.data?.spuResponse);
                    }
                });
                setProductPageData(productPageData);
            });
        };

        getProductSeriesData();
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    }, []);
    return (
        <section className={styles.spec}>
            <ProductNav activeTab={'Specs'} />
            {/* {productDataA.spuId && (
                <ProductSpecs productCatagory={productDataA.productCatagory} productDetail={productDataA.productDetail} theme={productPageTheme} />
            )} */}
            <EfProductMultiSpec
                items={[...productPageData?.productSeries]}
                catagories={formatMultiSpecData(productPageData?.productCatagory, [...productPageData?.productSeries])}
                theme={productPageTheme}
            />
        </section>
    );
}
